import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import moment from "moment";
import API from "../../../API";
import CRUDTable from "../../../Shared/CRUDTable";
import { Roles } from "../../../../constants";
import * as validationSchemas from "../../../validationSchemas";
import useFetch from "../../../CustomHooks/useFetch";
import { showNotification } from "../../../../utils";
import { Form } from "react-bootstrap";
import ButtonWithLoading from "../../../Shared/ButtonWithLoading";

const validationSchema = Yup.object({
  name: validationSchemas.readableText.label("Name").required(),
  email: validationSchemas.email.label("Email").required(),
  phone: validationSchemas.phone.label("Phone number").required(),
  pw: validationSchemas.password.label("Password").required(),
});
const formatNotificationText = (offer) => {
  const discountText = offer.discount_type
    ? `${offer.discount}% discount`
    : `FLAT ₹${offer.discount} OFF`;

  return `Use code ${offer.code.toUpperCase()} and get ${discountText} on any purchase`;
};
const SendNotificationButton = ({  row }) => {
  const [selectedOfferIdx, setSelectedOfferIdx] = useState(0);
  //const {data: offers,  callAPI, pending } = useFetch(API("IntrodcutoryVoucher").post.JSON("status-update"));
  const [selectedStatus, setSelectedStatus] = useState(row.status);
 const [pending, setPending] = useState(false);
  const handleSendNotification = () => {
   // const selectedOffer = offers[selectedOfferIdx];
    // callAPI(
    //   {
    //     status: selectedStatus,
    //     id: row.id,
    //   },
    //   () =>{
    //   //   if(offers.status==1){
    //   //     console.log(offers)
    //   //   showNotification({
    //   //     msg: "Status updated",
    //   //   });
    //   //   setTimeout(() => {
    //   //     window.location.reload()
    //   //   }, 1000);
    //   // } else {
    //   //   showNotification({
    //   //     msg: "Couldn't update status",
    //   //     type: "danger",
    //   //   }); }
        
    //   },
    //   () =>
    //     showNotification({
    //       msg: "Couldn't update status",
    //       tyoe: "danger",
    //     })
    // );
     setPending(true);
       API("IntrodcutoryVoucher").post.JSON("status-update")({
         status: selectedStatus,
         id: row.id,
       })
      .then((data) => {
        setPending(false);
       if(data?.status==1){
        //console.log(offers)
        showNotification({
          msg: "Status updated",
        });
        setTimeout(() => {
          window.location.reload()
        }, 2000);
      }else{
         showNotification({
          msg: "Couldn't update status",
          tyoe: "danger",
        })
      }
      })
      .catch((err) => {
        setPending(false);
         showNotification({
          msg: "Couldn't update status",
          tyoe: "danger",
        })
        console.error(err);
      });
  };

  return (
    <div className="d-flex flex-grow-1 col-md-6" style={{width: "125%"}} >
      <Form.Select
        onChange={(e) => setSelectedStatus(e.target.value)}
          defaultValue={selectedStatus}
      >
          <option  value="Not Used">
            Not Used
          </option>
          <option  value="Used">
            Used
          </option>
      </Form.Select>
      <ButtonWithLoading loading={pending}   onClick={handleSendNotification}>
        Save
      </ButtonWithLoading>
    </div>
  );
};
const Voucher = () => {
   //const { data: offers, callAPI, pending } = useFetch(API("offer").get());

  const renderButton = (row) => (
    <SendNotificationButton {...{  row }} />
  );

  // useEffect(() => {
  //   callAPI();
  // }, []);
  return (
    <CRUDTable
      API={API("IntrodcutoryVoucher")}
      idExtractor={(data) => data.id}
      tableName="Introdcutory Voucher"
      //hideEditButton
      //hideDeleteButton
      hideAddButton
      config={{
        columns: [
          {
            label: "Name",
            db_name: "name",
            gridOptions: { md: 12 },
          },
          {
            label: "Email",
            db_name: "email",
            gridOptions: { md: 6 },
            
          },
           {
            label: "Phone",
            db_name: "phone",
            gridOptions: { md: 6 },
            
          },
           {
            label: "Voucher",
            db_name: "voucher",
            gridOptions: { md: 6 },
            
          },
          {
            label: "Age",
            db_name: "age",
            gridOptions: { md: 6 },
            
          },
           {
            label: "Group category",
            db_name: "groupcategory",
            gridOptions: { md: 6 },
            
          },
           {
            label: "Category",
            db_name: "category",
            gridOptions: { md: 6 },
            
          },
           {
            label: "IP",
            db_name: "ip",
            gridOptions: { md: 6 },
            
          },
          {
            label: "CreatedAt",
            db_name: "createdAt",
            gridOptions: { md: 6 },
            
          },
          {
            label: "Status",
            db_name: "status",
            gridOptions: { md: 6 },
            
          },
         
        ],
        formikProps: {
          validationSchema,
        },
      }}
     renderActions={renderButton}

    />
  );
};

export default Voucher;
